/**
 * WP Dark Mode Social Share
 * Added from 2.3.7
 */
import WPDMAlpine from "alpinejs";
import axios from "axios";

import "./upgrade";
import "./tooltip";

(function () {
    const { __ } = wp.i18n;

    const t = (key) => window.wp_dark_mode_admin_json?.strings?.[key] || key;

    /**
     * Main core class of the module
     */
    const SocialShareApp = {
        t,
        /**
         * States as temporary variables
         */
        state: {
            noWatch: true,
            activeTab: "channels",
            search_channels: "",
            showAllChannels: false,
            channels: [],
            post_types: 2,
            showAllChannels: false,
            draggingChannel: 'unknown',
            promptModal: {
                show: false,
                channel: null,
                prompt: ''
            }
        },

        constant: {
            tabs: [
                {
                    id: "channels",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-share-fill" viewBox="0 0 16 16">
          <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"/>
        </svg>`,
                    title: t( "social_channels" ),
                },
                {
                    id: "customization",
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-palette" viewBox="0 0 16 16">
          <path d="M8 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm4 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM5.5 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
          <path d="M16 8c0 3.15-1.866 2.585-3.567 2.07C11.42 9.763 10.465 9.473 10 10c-.603.683-.475 1.819-.351 2.92C9.826 14.495 9.996 16 8 16a8 8 0 1 1 8-8zm-8 7c.611 0 .654-.171.655-.176.078-.146.124-.464.07-1.119-.014-.168-.037-.37-.061-.591-.052-.464-.112-1.005-.118-1.462-.01-.707.083-1.61.704-2.314.369-.417.845-.578 1.272-.618.404-.038.812.026 1.16.104.343.077.702.186 1.025.284l.028.008c.346.105.658.199.953.266.653.148.904.083.991.024C14.717 9.38 15 9.161 15 8a7 7 0 1 0-7 7z"/>
        </svg>`,
                    title: t( "customization" ),
                },
                // {
                //   id: "social-meta",
                //   icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-code-slash" viewBox="0 0 16 16">
                //   <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z"/>
                // </svg>`,
                //   title: "Social Meta",
                // },
            ],
            button_positions: {
                above: t( "above" ),
                below: t( "below" ),
                both: t( "above_below" ),
            },
            button_alignments: {
                left: t( "left" ),
                center: t( "center" ),
                right: t( "right" ),
                stretch: t( "stretch" ),
            },
            button_shapes: {
                rounded: t( "rounded" ),
                circle: t( "circle" ),
                rectangular: t( "rectangular" ),
                slanted: t( "slanted" ),
            },
            button_sizes: {
                1: "S",
                1.2: "M",
                1.4: "L",
                1.6: "XL",
            },
            button_labels: {
                channel_label: t( "channel_label" ),
                share_count: t( "share_count" ),
                both: t( "both" ),
                none: t( "none" ),
            },
            devices: {
                mobile: {
                    name: t( "mobile" ),
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" class="fill-current w-4" viewBox="0 0 16 16">
          <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5z"/>
          <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
        </svg>`,
                },
                desktop: {
                    name: t( "desktop" ),
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" class="fill-current w-5" viewBox="0 0 16 16">
          <path d="M13.5 3a.5.5 0 0 1 .5.5V11H2V3.5a.5.5 0 0 1 .5-.5h11zm-11-1A1.5 1.5 0 0 0 1 3.5V12h14V3.5A1.5 1.5 0 0 0 13.5 2h-11zM0 12.5h16a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5z"/>
        </svg>`,
                },
            },
        },

        get isUltimate() {
            return [true, 1, '1', 'true'].includes(wp_dark_mode_social_share.is_ultimate);
        },

        get isPro() {
            return this.isUltimate
        },

        get isFree() {
            return !this.isPro;
        },

        /**
         * Set Tab
         */
        setTab(tab) {
            this.state.activeTab = tab;
            window.location.hash = tab;
        },

        /**
         * Init Tab
         */
        initTab() {
            if (window.location.hash) {
                let hash = window.location.hash.substr(1);
                if (this.constant.tabs.find((tab) => tab.id === hash)) {
                    this.setTab(hash);
                }
            }
        },

        freeChannels: ["facebook", "twitter", "pinterest", "reddit", "copy", "chatgpt", "grok", "perplexity", "gemini", "claude"],
        /**
         * Init Channels
         */
        initChannels() {
            let channels = wp_dark_mode_social_share.channels;
            const enabledChannels = this.isFree
                ? this.freeChannels
                : channels.map((channel) => channel.id);

            channels.map((channel) => {
                channel.class = channel.class || `_icon-${channel.id}`;
                channel.enabled = enabledChannels.includes(channel.id);
                return channel;
            });

            this.state.channels = channels || [];
        },

        /**
         * Channel getter
         */

        get channels() {
            return this.state.channels;
        },
        get filteredChannels() {
            const { search_channels } = this.state;

            if (!search_channels) {
                return !this.state.showAllChannels
                    ? this.channels.slice(0, 10)
                    : this.channels;
            }

            var channels = this.channels.filter((channel) => {
                const search_in = [channel.name.toLowerCase(), channel.id]

                // if tags are available, merge them
                if (channel.tags) {
                    search_in.push(...channel.tags);
                }

                return search_in.some(tag => tag.includes(search_channels.toLowerCase()));
            });

            return !this.state.showAllChannels ? channels.slice(0, 15) : channels;
        },

        /**
         * Binding backends
         */
        options: {
            enable: false,
        },

        get getOptions() {
            return this.options;
        },

        isTab(tab = "channels") {
            return this.state.activeTab === tab;
        },

        get currentTab() {
            return this.constant.tabs.find((tab) => this.isTab(tab.id));
        },

        showPromo() {
            // Plugin SDK
            // WPPOOL.Popup('wp_dark_mode').show();

            // Legacy Popup
            window.WPDarkModePromo.show();
        },

        /***
         * Enable/Disable channel
         */
        toggleChannel(channelId, enable = null) {
            const allChannels = this.state.channels;
            let enabledChannels = this.getOptions.channels;

            const channel = allChannels.find(
                (currentChannel) => currentChannel.id === channelId
            );

            /**
             * If channel is NOT active, show promo message
             */

            const channelIndex = enabledChannels.findIndex(
                (currentChannel) => currentChannel.id === channelId
            );

            if (channelIndex < 0) {
                if (!channel.enabled) {
                    this.showPromo();
                    return;
                }

                enabledChannels.push({
                    id: channel.id,
                    name: channel.name,
                    visibility: {
                        desktop: true,
                        mobile: true,
                    },
                });
            } else {
                enabledChannels.splice(channelIndex, 1);
            }

            this.options.channels = enabledChannels;
        },

        get enabledChannels() {
            return this.options.channels || [];
        },

        /**
         * Is channel enabled
         */
        isChannelEnabled(channel) {
            return this.enabledChannels.find(
                (currentChannel) => currentChannel.id === channel
            );
        },

        get enabledChannelsForPreview() {
            if (!this.enabledChannels || !this.options || typeof this.options.channel_visibility === 'undefined') {
                return [];
            }
            return this.enabledChannels.slice(0, this.options.channel_visibility || 2);
        },

        getIcon(channelId) {
            const channel = this.channels.find(
                (currentChannel) => currentChannel.id === channelId
            );
            return channel.svg || channel.icon;
        },

        /**
         * draggingChannel
         */

        handleDrag(event, channelId) {
            event.preventDefault();

            if (!this.state.draggingChannel) return;

            let channels = this.options.channels || [];
            let draggingChannel = this.state.draggingChannel;

            let draggingChannelIndex = channels.findIndex(
                (currentChannel) => currentChannel.id === draggingChannel
            );
            let targetChannelIndex = channels.findIndex(
                (currentChannel) => currentChannel.id === channelId
            );

            if (draggingChannelIndex === -1 || targetChannelIndex === -1) return;

            let temp = channels[draggingChannelIndex];
            channels[draggingChannelIndex] = channels[targetChannelIndex];
            channels[targetChannelIndex] = temp;

            this.options.channels = channels;
        },

        handleDrop(event, channelId) {
            this.state.draggingChannel = null;
        },

        /**
         * Init Options
         */
        async initOptions() {
            const optionKeys = Object.keys(wp_dark_mode_social_share.options);

            const optionValues = Object.values(wp_dark_mode_social_share.options).map(
                (value) => {
                    if (value === "1") return true;
                    if (value === "0") return false;

                    if (typeof value === "object") {
                        if ("mobile" in value) {
                            value.mobile = value.mobile === "1";
                        }

                        if ("desktop" in value) {
                            value.desktop = value.desktop === "1";
                        }

                        return value;
                    }

                    return value;
                }
            );

            const options = {
                enable: false,
            };

            optionKeys.forEach((key, index) => {
                let value = optionValues[index];
                options[key] = value;
            });

            if (this.isFree) {
                options.channels = options.channels.filter((channel) =>
                    this.freeChannels.includes(channel.id)
                );

                options.button_template = 1;

                options.hide_button_on = options.hide_button_on || {};
                options.hide_button_on.mobile = false;
                options.hide_button_on.desktop = false;

                const freePostTypes = ["post", "page"];

                options.post_types = options.post_types.filter((postType) =>
                    freePostTypes.includes(postType)
                );

                options.button_spacing = true;
                options.show_total_share_count = false;
            }
            // not ultimate
            if (!this.isPro) {
                options.minimum_share_count = 0;
                options.maximum_click_count = 30;
                options.channel_visibility = 3;
            }

            this.state.noWatch = true;
            this.options = options;
            this.state.savedOptions = JSON.parse(JSON.stringify(options));

            try {
                await this.saveOptions(options, true);
            } catch (error) {
                console.error("Error saving options:", error);
            } finally {
                this.state.noWatch = false;
            }
        },

        /**
         * Init Post Types
         */
        initPostTypes() {
            this.constant.post_types = Object.values(
                wp_dark_mode_social_share.post_types
            ).filter((postType) => {
                return postType.id !== "attachment";
            });
        },

        init() {
            // Set default values for state
            this.state = this.state || {};
            this.state.activeTab = this.state.activeTab || "channels";
            this.state.search_channels = this.state.search_channels || "";
            this.state.showAllChannels = this.state.showAllChannels || false;
            this.state.channels = this.state.channels || [];
            this.state.post_types = this.state.post_types || 2;
            this.state.draggingChannel = this.state.draggingChannel || 'unknown';
            this.state.isChanged = this.state.isChanged || false;
            this.state.saved = this.state.saved || false;

            // Init options
            this.initOptions();

            // Bind events
            this.bindEvents();

            // initTab
            this.initTab();

            // initChannels
            this.initChannels();

            // Init post types
            this.initPostTypes();

            // Watch for changes
            this.$watch("options", this.onOptionsChange.bind(this));

            // Hide skeleton loader
            setTimeout(() => {
                const loader = document.getElementById("wpdm-social-share-loader");
                if (loader) {
                    loader.style.display = 'none';
                }
            }, 1200);
        },

        /**
         *  On Option Change
         */

        onOptionsChange(value, oldValue) {
            if (this.state.noWatch === true) {
                this.state.isChanged = false;
            } else {
                this.state.isChanged = true;
            }
        },

        /**
         * Is changed options
         */
        get isChanged() {
            return this.state.isChanged;
        },

        /**
         * Update preview
         */

        updatePreview() {
            document.documentElement.style.setProperty(
                "--wpdm-social-share-scale",
                this.options.button_size
            );
        },

        /**
         * setPostTypes
         */
        togglePostType(postType) {
            if (!Array.isArray(this.options.post_types)) {
                this.options.post_types = [];
            }

            if (this.options.post_types.includes(postType)) {
                this.options.post_types = this.options.post_types.filter(
                    (currentPostType) => currentPostType !== postType
                );
            } else {
                this.options.post_types.push(postType);
            }
        },

        // toggleArchive(archive) {
        //   if (this.options.archives.includes(archive)) {
        //     this.options.archives = this.options.archives.filter(
        //       (currentArchive) => currentArchive !== archive
        //     );
        //   } else {
        //     this.options.archives.push(archive);
        //   }
        // },

        /**
         * Upload image
         */
        // openFileUploader() {
        //   const fileUploader = wp
        //     .media({
        //       title: "Select Image",
        //       button: {
        //         text: "Select Image",
        //       },
        //       multiple: false,
        //     })
        //     .open();

        //   fileUploader.on("select", () => {
        //     const attachment = fileUploader
        //       .state()
        //       .get("selection")
        //       .first()
        //       .toJSON();
        //     this.options.default_share_image = attachment.url;
        //   });
        // },

        async toggleSocialShare() {
            if (this.options.saved === true) {
                // Start by making a clean copy of saved options
                const savedOptions = JSON.parse(JSON.stringify(this.state.savedOptions));
                savedOptions.enable = Boolean(this.options.enable);

                this.state.noWatch = true;
                this.options = JSON.parse(JSON.stringify(savedOptions));
                this.state.noWatch = false;
                this.state.savedOptions = savedOptions;

                try {
                    await this.saveOptions(savedOptions);
                    this.state.isChanged = false;
                } catch (error) {
                    console.error("Error saving options:", error);
                    this.state.isChanged = true;
                }
            } else {
                this.options.saved = true;
                this.state.isChanged = true;
                this.state.noWatch = false;
            }
        },

        async saveOptionsButton() {
            const options = JSON.parse(JSON.stringify(this.getOptions));
            await this.saveOptions(options);
        },

        /**
         * Save Options
         */
        async saveOptions(options = null, silence = false) {
            this.state.isChanged = false;

            if (options === null) {
                options = JSON.parse(JSON.stringify(this.getOptions));
            }

            // Saved
            if (!silence) {
                clearTimeout(this.state.savedTimer);
                this.state.saved = true;

                this.state.savedTimer = setTimeout(() => {
                    this.state.saved = false;
                }, 2500);
            }

            this.state.isChanged = false;
            const response = await axios.post(
                wp_dark_mode_social_share?.ajax_url + "?action=wpdm_social_share_save_options",
                {
                    options: options,
                    security_key: wp_dark_mode_social_share.security_key,
                }
            );

            const data = response.data;
            // Log(data);

            if (data.success) {
                this.state.savedOptions = data.data;
                this.state.isChanged = false;
            }
        },

        bindEvents() {
            const Tooltips = document.querySelectorAll(".wpdarkmode-tooltip");
            if (Tooltips.length > 0) {
                Tooltips.forEach(function (tooltip) {
                    /**
                     * Add icon
                     */
                    const svg = `<svg xmlns="http://www.w3.org/2000/svg" class="_icon-svg" viewBox="0 0 16 16"><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/></svg>`;
                    const Icon = document.createElement("span");
                    Icon.classList.add("_icon-tooltip");
                    Icon.innerHTML = svg;

                    // inject icon

                    tooltip.appendChild(Icon);

                    // Mouse events
                    tooltip.addEventListener(
                        "mouseenter",
                        function () {
                            const title =
                                this.getAttribute("title") || this.getAttribute("data-title");
                            this.setAttribute("data-title", title);
                            this.setAttribute("title", "");
                            const TooltipContent =
                                this.querySelector(".wpdarkmode-tooltip-content") ||
                                document.createElement("div");
                            TooltipContent.classList.add("wpdarkmode-tooltip-content");
                            TooltipContent.innerHTML = title;
                            TooltipContent.style.display = "nonde";
                            this.appendChild(TooltipContent);
                            jQuery(TooltipContent).fadeIn();
                        }.bind(tooltip)
                    );

                    tooltip.addEventListener(
                        "mouseleave",
                        function () {
                            const TooltipContent = this.querySelector(
                                ".wpdarkmode-tooltip-content"
                            );
                            if (TooltipContent) {
                                jQuery(TooltipContent).fadeOut();
                                this.removeChild(TooltipContent);
                            }
                        }.bind(tooltip)
                    );

                    const badges = document.querySelectorAll(
                        ".badge-pro, .badge-ultimate"
                    );
                    if (badges && badges.length > 0) {
                        badges.forEach((badge) => {
                            badge.addEventListener("click", () => {
                                SocialShareApp.showPromo();
                            });
                        });
                    }
                });
            }
        },

        Nothing() {
            return true;
        },
        randomNumber(from = 10, to = 100) {
            return Math.floor(Math.random() * (to - from + 1) + from);
        },

        // editableChannel
        editableChannel(event) {
            const previousDiv = event.target.previousElementSibling;

            if (previousDiv) {
                previousDiv.focus();
            }

        },
        // Check if channel is AI type using PHP data
        isAIChannel(channelId) {
            const channel = wp_dark_mode_social_share.channels.find(c => c.id === channelId);
            return channel && channel.type === 'ai_prompt';
        },
        getChannelPrompt(channelId) {
            // First check if user has set a custom prompt for this channel
            const userChannel = this.options.channels.find(c => c.id === channelId);
            if (userChannel && userChannel.prompt) {
                return userChannel.prompt;
            }

            // Otherwise get the default from PHP channel data
            return this.getDefaultPrompt(channelId);
        },

        // Open prompt edit modal
        editPrompt(channel) {
            // If free version, show the modal but in disabled state
            // The modal itself handles the disabled logic via Alpine.js
            this.state.promptModal.channel = channel;

            // Get the current prompt (user custom or default)
            const currentPrompt = this.getChannelPrompt(channel.id);
            this.state.promptModal.prompt = currentPrompt;

            this.state.promptModal.show = true;
        },

        // Close prompt modal
        closePromptModal() {
            this.state.promptModal.show = false;
            this.state.promptModal.channel = null;
            this.state.promptModal.prompt = '';
        },

        // Get default prompt from PHP channel data
        getDefaultPrompt(channelId = null) {
            if (channelId) {
                // Use the channels data passed from PHP
                const channel = wp_dark_mode_social_share.channels.find(c => c.id === channelId);
                if (channel && channel.prompt) {
                    return channel.prompt;
                }
            }

            // Fallback for unknown channels
            return t('default_ai_prompt');
        },

        // Get channel specific prompt (check user custom first, then PHP default)
        getChannelPrompt(channelId) {
            // First check if user has set a custom prompt for this channel
            const userChannel = this.options.channels.find(c => c.id === channelId);
            if (userChannel && userChannel.prompt) {
                return userChannel.prompt;
            }

            // Otherwise get the default from PHP channel data
            return this.getDefaultPrompt(channelId);
        },

        // Reset prompt to PHP default
        resetToDefault() {
            if (this.state.promptModal.channel) {
                const defaultPrompt = this.getDefaultPrompt(this.state.promptModal.channel.id);

                // Update the modal prompt immediately
                this.state.promptModal.prompt = defaultPrompt;

                // Also update the channel in options immediately
                const channelIndex = this.options.channels.findIndex(
                    c => c.id === this.state.promptModal.channel.id
                );

                if (channelIndex >= 0) {
                    // Reset to default by removing custom prompt or setting to default
                    this.options.channels[channelIndex].prompt = defaultPrompt;
                }
            }
        },

        // Update channel prompt in real-time
        updateChannelPrompt() {
            if (this.state.promptModal.channel) {
                const channelIndex = this.options.channels.findIndex(
                    c => c.id === this.state.promptModal.channel.id
                );

                if (channelIndex >= 0) {
                    // Make sure we update the actual channel prompt
                    this.options.channels[channelIndex].prompt = this.state.promptModal.prompt;
                }
            }
        },

        // Done button handler
        donePrompt() {
            // Make sure the final prompt is saved before closing
            this.updateChannelPrompt();
            this.closePromptModal();
        },
    };

    // document.addEventListener("DOMContentLoaded", function () {
    WPDMAlpine.data("SocialShare", () => SocialShareApp);

    // init WPDMAlpine
    window.WPDMAlpine = WPDMAlpine;

    // init WPDMAlpine
    WPDMAlpine.start();


})(jQuery);
